<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}<span v-if="box.extra" class="extra_price"> + {{ box.extra }} €</span>
        </div>
        <!-- SEARCHBOX -->

        <!-- FILTERBOXES -->
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <div class="fabric-select-btn-box">
            <div :id="box.component" class="fabric-select-btns">

                <div v-for="item in items"
                     v-bind:class="[ 'fabric-select-btn', isactive === item.ref_number ? 'active' : '' ]">
                    <img v-bind:src="this.baseurl + 'media/' + item.thumb" v-bind:alt="item.name"
                         v-bind:title="item.name" v-bind:id="item.ref_number" v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color_code" @click="updatePersonal"/>
                    <div class="name" v-bind:title="item.name" v-bind:id="item.ref_number"
                         v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color_code" @click="updatePersonal">{{ item.name }}
                    </div>
                    <button v-bind:class="[ 'zoom-btn', 'btn-standalone', (isactive === itemref_number || item.ref_number === this.personal[box.component]) ? 'active' : '' ]"
                            v-bind:data-refnr="item.ref_number"
                            v-bind:data-title="item.name" v-bind:data-infotext='item.infotext'
                            v-bind:data-price='item.price'
                            type="button" @click="zoomFabric">Details
                    </button>
                </div>
            </div>
        </div>
    </div>
    <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals"></zoom>
</template>
<script>
import Zoom from '../partials/Zoom.vue'

export default {
  name: 'Fit',
  data: function () {
    return {
      globals: window.shirtdesigner,
      show: {
        type: Boolean,
        required: true,
        twoWay: true
      }
    }
  },
  props: [ 'fabrics', 'items', 'box', 'filtertext', 'zoom', 'show', 'baseurl', 'personal', 'isactive', 'personal', 'selectBoxes' ],
  components: {
    Zoom
  },
  methods: {
    updatePersonal: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      if (event.currentTarget.dataset.btncolor) {
        this.$dispatch('updatePersonalData', [ 'button-color', event.currentTarget.dataset.btncolor ])
      }
      this.isactive = event.currentTarget.id
      if (event.currentTarget.dataset.component === 'sleeve' && event.currentTarget.id !== 'long' && (this.personal['monopos'] === 'cuffleft' || this.personal['monopos'] === 'cuffright')) {
        this.$dispatch('updatePersonalData', ['monogramm', ''])
        this.$dispatch('updatePersonalData', ['monopos', 'waistleft'])
      }
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/jack/shirt/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    }
  },
  ready: function () {
    this.$dispatch('runDesignJQuery')
  }
}

</script>



// WEBPACK FOOTER //
// Fit.vue?733a6dd0